exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{\r\n    border-radius: 3px;\r\n}\r\n.btn-download\r\n{\r\n    border: 1px solid #ccc!important;\r\n    border-radius: 5px;\r\n    padding: 3px 10px!important;\r\n    background-color: #fff;\r\n    margin-left: 10px ;\r\n}\r\n:host ::ng-deep .ui-calendar-button\r\n{\r\n    border-top-left-radius: 5px!important;\r\n    border-top-right-radius: 0px!important;\r\n    border-bottom-left-radius: 5px!important;\r\n    border-bottom-right-radius: 0px!important;\r\n}\r\n:host ::ng-deep .ui-calendar .ui-inputtext\r\n{\r\n    border-right: 1px solid!important;\r\n    border-right-color: #a6a6a6!important;\r\n    border-top-right-radius: 5px!important;\r\n    border-bottom-right-radius: 5px!important;\r\n    border-top-left-radius: 0px!important;\r\n    border-bottom-left-radius: 0px!important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/MSVFile/file-list/file-list.component.css
// module id = ../../../../../src/app/MSVFile/file-list/file-list.component.css
// module chunks = main